"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
exports.default = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        backdropFilter: 'blur(4px)',
        width: '100%',
        height: '100%',
        zIndex: 5,
        position: 'absolute',
        backgroundColor: 'rgba(111, 126, 140, 0)',
    });
});
